import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltCommentDialogCustomAnnotationDropdownTriggerArrow = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-trigger-arrow-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentDialogCustomAnnotationDropdownTriggerArrow;
